// extracted by mini-css-extract-plugin
module.exports = {"container":"CurrentUser_container__LFXpv","button":"CurrentUser_button__dhnZ3","confirming":"CurrentUser_confirming__pKO_r","userInfoHover":"CurrentUser_userInfoHover__9rO7t"};